import React from 'react';
import { useSelector } from 'react-redux';
import SC_ManageData from '../SC_ManageData';
import SC_ManageGate from '../SC_ManageGate';
import { RootState } from '../../../redux/checkoutredux/store/checkoutStore';

const ElementFreeShip: React.FC = () => {
  const total = useSelector((state: RootState) => state.shoppingcart.metacartdata?.[0]?.totalprice || 0);
  const settings = useSelector((state: RootState) => state.sidecartsettings.appSettings);
  const alwaysFreeShippingCategories = useSelector(
    (state: RootState) => state.generalsettings.generalSettings?.alwaysFreeShippingCategories || []
  );
  const autocheckFreeShipping = useSelector(
    (state: RootState) => state.shoppingcart.metacartdata?.[0]?.free_shipping_available || false
  );

  if (settings?.freeShipping === 'custom') {
    const cartTotal = total;
    const freeShippingAmount = parseFloat(settings.freeShipping_amount || '0');
    let progressPercentage = (cartTotal / freeShippingAmount) * 100;

    const textnext1 = settings.freeShipping_success || 'Free shipping achieved!';
    const textnext2 = settings.freeShipping_nexttext || 'Spend %s more to get free shipping.';
    const restprice = freeShippingAmount - cartTotal;

    const incartCategories = SC_ManageGate.get_catids_fromcart(); // Kategorien der Sidecart

    const hasFreeShippingCategory = incartCategories.some((cartCatArray: any[]) =>
      cartCatArray.some((catId) => alwaysFreeShippingCategories.includes(Number(catId)))
    );

    let replacedText: JSX.Element | string;

    if (hasFreeShippingCategory || autocheckFreeShipping) {
      progressPercentage = 100;
      replacedText = textnext1; // Erfolgsmeldung für kostenlosen Versand
    } else if (cartTotal >= freeShippingAmount) {
      progressPercentage = 100;
      replacedText = textnext1;
    } else {
      const index = textnext2.indexOf('%s');
      const textBefore = textnext2.slice(0, index);
      const textLast = textnext2.slice(index + 2);
      replacedText = (
        <>
          {textBefore}
          <strong>{SC_ManageData.convertToEuro(restprice)}€</strong>
          {textLast}
        </>
      );
    }

    return (
      <div className="ips-sidecart-free-shipping-progress-wrap">
        <p className="ips-xtra-small">{replacedText}</p>
        <div className="ips-sidecart-free-shipping-progress">
          <div
            className="ips-sidecart-free-shipping-progress-indicator"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
      </div>
    );
  }

  return null; // Wenn `settings.freeShipping` nicht 'custom' ist, zeige nichts an
};

export default ElementFreeShip;